module.exports = __webpack_public_path__ + "img/poseCCI.40556028.jpg";